import { BaseQueryOptions } from '@apollo/client'
import { graphql, ChildProps } from '@apollo/client/react/hoc'
import { ApplicationError } from '../../helpers/errors'
import { CFEvent, CFOffer, CFCentre } from '../../../types/contentful'
import { WhatsOnRange } from '../../../types/whats-on'
import { WHATS_ON_QUERY } from './query'

export const query = WHATS_ON_QUERY

interface Response {
  whatsOnCentre?: (CFEvent | CFOffer)[]
}

interface Variables {
  centreId: string
  durationFromNow: string
  timeZone: string
}

interface InputProps {
  centre: CFCentre
}

interface Props {
  error?: Error
  loading?: boolean
  whatsOnList?: WhatsOnRange[]
  offers?: CFOffer[]
  events?: CFEvent[]
  centre?: CFCentre
}

export const mapPropsToOptions = ({
  centre,
}: InputProps): BaseQueryOptions<Variables> => ({
  variables: {
    centreId: centre.sys.id,
    durationFromNow: 'P7W1D',
    timeZone: centre.timeZone,
  },
  errorPolicy: 'ignore',
  context: { version: 2 },
})

export const mapDataToProps = (
  props: any
): ChildProps<Props, Response, Variables> => {
  const { ownProps, data } = props
  const { centre } = ownProps
  if (!data) {
    return {
      error: new ApplicationError('No data'),
    }
  }

  const { error, loading, whatsOnCentre } = data
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }

  const allItems = whatsOnCentre || []

  const events: CFEvent[] = allItems.filter(
    (item: CFEvent | CFOffer): boolean => item.__typename === 'CFEvent'
  ) as CFEvent[]
  const offers: CFOffer[] = allItems.filter(
    (item: CFEvent | CFOffer): boolean => item.__typename === 'CFOffer'
  ) as CFOffer[]
  return { offers, events, centre }
}

const withWhatsOnList = graphql<InputProps, Response, Variables>(
  WHATS_ON_QUERY,
  {
    options: mapPropsToOptions,
    props: mapDataToProps,
  }
)

export default withWhatsOnList
